<template lang="html">
  <div class="">
    <v-snackbar
         v-model="ViewNotif"
         color="info"
         :timeout="timeout"
         top
         class="ViewNotif"
      >
         <p style="ViewNotif__Text">{{AlertText}}</p>
         <!-- <v-btn class="ma-2" color="warning" @click="ReloadBrowser">
            <v-icon dark right>sync</v-icon>
         </v-btn> -->
    </v-snackbar>
    <Header v-if="studentAuth == 'student'"/>
    <Sidenav v-if="studentAuth == 'student'" />
    <div class="main">
      <div class="" v-if="GET_AdditionaLinfo != null">
        <div class="server__time--mobile hidden-sm-and-up" v-if="!handleServerTime">
          Loading..
        </div>
        <div class="server__time--mobile hidden-sm-and-up" v-if="handleServerTime">
          <div class="server__time--time mobile">
            <div class="">
              <label ref="hours">{{splitHours}}</label>:<label ref="minutes">{{splitMinutes}}</label>
            </div>
            <span>({{GET_AdditionaLinfo.gmt}})</span>
            <i @click="show = !show">i</i>
          </div>
        </div>
        <transition name="slide-down">
          <div class="tooltip--server mobile" v-show="show">
            <span>This is time based on your timezone setting based on your last configuration, if you wish to change it you can go to Profile settings</span>
          </div>
        </transition>
      </div>
      <router-view></router-view>
    </div>
    <!-- <lottie :options="defaultOptions" v-on:animCreated="handleAnimation" style="position:absolute;" /> -->
    <!-- <div>
      <p>Speed: x{{animationSpeed}}</p>
      <input type="range" value="2" min="0" max="3" step="0.5"
      v-on:click="onSpeedChange" v-model="animationSpeed">
    </div>  -->
    <Bottomnav
      v-if="studentAuth == 'student'"
      class="hidden-md-and-up"
    />
  </div>
</template>

<script>
import moment from 'moment'
import Header from '../../student-components/layout/Header'
import Sidenav from '../../student-components/layout/Sidenav'
import CoachHeader from '../../coach-components/CoachLayout/CoachHeader'
import CoachSidenav from '../../coach-components/CoachLayout/CoachSidenav'
import Bottomnav from '../../student-components/layout/Bottomnav'
import CoachBottomnav from '../../coach-components/CoachLayout/CoachBottomnav'
import Lottie from '../../components/loading/Lottie'
import * as animationData from '../../staticjson/starss.json';
export default {
  props:[
    'LotteLoader'
  ],
  components: {
    Sidenav,
    Header,
    CoachSidenav,
    CoachHeader,
    Bottomnav,
    CoachBottomnav,
    Lottie
  },
  data () {
    return {
      windowWidth:0,
			windowHeigt:0,
      Showing: false,
      showLottie:true,
      defaultOptions: {animationData: animationData},
      animationSpeed: 2,
      show: false,
      whichBrowser: true,
      ViewNotif:false,
      timeout:600000,
      AlertText:''
    }
  },
  created(){
     this.GetBrowser()
  },
  mounted() {
		this.$nextTick( () => {
			window.addEventListener('resize', this.getWindowWidth);
			window.addEventListener('resize', this.getWindowHeight);
			this.getWindowWidth()
			this.getWindowHeight()
		})

    let hoursLabel = this.$refs.hours;
    let minutesLabel = this.$refs.minutes;
    let totalMinutes = this.splitMinutes;
    let totalHours = this.splitHours;
    setInterval(setMin, 60000);
    setInterval(setHour, 3600000);

    function setMin() {
      ++totalMinutes;
      minutesLabel.innerHTML = min(totalMinutes % 60);
    }
    function setHour() {
      ++totalHours;
      hoursLabel.innerHTML = hour(totalHours % 24);
    }

    function min(val) {
      const valString = val + "";
      if (valString.length < 2) {
        return "0" + valString;
      } else {
        return valString;
      }
      console.log(valString);
    }
    function hour(val) {
      const valString = val + "";
      if (valString == 24) {
        return "0" + valString;
      } else {
        return valString
      }
    }
    clearInterval (setMin, setHour);

    // Safari 3.0+ "[object HTMLElementConstructor]"
    const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
    // console.log('to check browser' + isSafari);
    this.whichBrowser = isSafari
	},
  computed:{
    studentAuth () {
      return this.$store.state.UserRoleId
    },
    GET_AdditionaLinfo(){
			return this.$store.state.DataAdditional
    },
    getServerTime () {
      const data = this.$store.state.stateServerTime

      if (data == null) {
        return 0
      } else {
        return data.data
      }
    },
    handleServerTime () {
      let data = this.getServerTime

      if (data == 0) {
        return false
      } else {
        return true
      }
    },
    splitHours () {
      const data = this.getServerTime
      const hours = data.substr(11, 2)

      return hours
    },
    splitMinutes () {
      const data = this.getServerTime
      const minutes = data.substr(14, 2)

      return minutes
    },
    parseDate () {
      const data = moment(this.getServerTime).format('ddd, MMMM DD, YYYY')
      return data
    },
    // handleBrowser () {
    //   const data = this.whichBrowser
    //
    //   if (data == true) {
    //     return "no-webp"
    //   } else {
    //     return "webp"
    //   }
    // },
    GetAllert(){
      return this.$store.state.AllertCont ? this.$store.state.AllertCont : ''
    },
    stateServerTime () {
       return this.$store.state.stateServerTime
    }
  },
	methods: {
		getWindowWidth(event){
			this.windowWidth = document.documentElement.clientWidth;

			if (this.windowWidth <= 1023){
				//this for resolution ipad to mobile
				this.Showing = true
			}else if(this.windowWidth >= 1024){
				this.Showing = false
			}
		},

		getWindowHeight(event){
			this.windowHeigt = document.documentElement.clientHeight;
    },

    //FOR LOTTIE
    handleAnimation (anim) {
      this.anim = anim;
    },
    stop () {
      this.anim.stop();
    },
    play () {
      this.anim.play();
    },
    pause () {
      this.anim.pause();
    },
    onSpeedChange () {
      this.anim.setSpeed(this.animationSpeed);
    },
    GetBrowser(){
      var BrowserIs = null
      var codec = null
      // Opera 8.0+
      var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

      // Firefox 1.0+
      var isFirefox = typeof InstallTrigger !== 'undefined';

      // Safari 3.0+ "[object HTMLElementConstructor]"
      var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

      // Internet Explorer 6-11
      var isIE = /*@cc_on!@*/false || !!document.documentMode;

      // Edge 20+
      var isEdge = !isIE && !!window.StyleMedia;

      // Chrome 1 - 71
      var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

      // Blink engine detection
      var isBlink = (isChrome || isOpera) && !!window.CSS;

      if (isOpera){
        BrowserIs = 'isOpera'
        codec = 'vp8'
      }else if (isFirefox){
        BrowserIs = 'isFirefox'
          codec = 'h264'
      }else if (isSafari){
        BrowserIs = 'isSafari'
        codec = 'vp8'
      }else if (isIE){
        BrowserIs = 'isIE'
        codec = 'vp8'
      }else if (isIE){
        BrowserIs = 'isIE'
        codec = 'vp8'
      }else if (isChrome){
        BrowserIs = 'isChrome'
        codec = 'h264'
      }

      this.$store.commit('muttBrowserDetect',{
        Browser : BrowserIs,
        Codec : codec
      })
    },
	},
  watch: {
    stateServerTime (i) {
      if (i.status == 401) {
        this.interval = setInterval(() => {
          this.$store.dispatch('LOGOUT')
          window.location.reload()
        }, 3000)
      }
    },
    GetAllert(val){
      if (val.Alert === "yes"){
        this.ViewNotif = true
        this.AlertText = val.TextAlert
      }else if(val.Alert === "no"){
        this.ViewNotif = false
      }
    }
  },
	beforeDestroy() {
		window.removeEventListener('resize', this.getWindowWidth);
		window.removeEventListener('resize', this.getWindowHeight);
	},
}
</script>

<style lang="scss">
  	@import './Content.scss';

    .main__app {
      height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/views/content/Content.vue